import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { HappyPayWithdrawal } from '@features/user/interfaces/happy-pay.interface';
import { HappyPayWithdrawalService } from '@features/user/services/happy-pay-withdrawal.service';
import {
  faChevronDown,
  faChevronRight,
  faMinusSquare,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
  selector: 'fc-user-happy-pay-withdrawal',
  templateUrl: './user-happy-pay-withdrawal.component.html',
  styleUrls: ['./user-happy-pay-withdrawal.component.css'],
})
export class UserHappyPayWithdrawalComponent implements OnInit {
  private readonly destroy$ = new Subject<void>();

  faChevronRight = faChevronRight;
  faChevronDown = faChevronDown;
  faMinusSquare = faMinusSquare;
  faSpinner = faSpinner;

  @Input() dateFilter = null;

  withdrawals: HappyPayWithdrawal[] = [] as HappyPayWithdrawal[];
  hideLoadMore = true;
  currentPage: number = 0;
  loading = false;

  stateSubscription: Subscription;

  constructor(private happyPayWithdrawalService: HappyPayWithdrawalService) {
    this.stateSubscription = this.happyPayWithdrawalService
      .getNewHPWithdrawState()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.withdrawals = [];
        this.currentPage = 0;
        this.hideLoadMore = true;
        this.loadWithdrawal();
      });
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    // need dateFilter
    // if(!changes.dateFilter.firstChange) {
    //   this.withdrawals = [];
    //   this.currentPage = 0;
    //   this.hideLoadMore = false;
    //   this.loadWithdrawal();
    // }
  }

  loadWithdrawal() {
    this.currentPage += 1;
    this.loading = true;
    this.happyPayWithdrawalService
      .getHappyPayWithdrawals(6, this.currentPage, this.dateFilter)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          data.withdrawals.forEach((x) => {
            this.withdrawals.push(x);
            x.toggle = false;
          });
          if (this.withdrawals.length >= data.totalItems)
            this.hideLoadMore = true;
          this.loading = false;
        },
        (error: any) => {
          this.loading = false;
        }
      );
  }

  cancel(withdrawalId: number) {
    this.happyPayWithdrawalService
      .deleteHappyPayWithdrawal(withdrawalId)
      .subscribe(
        (res) => {
          this.loadWithdrawal();
        },
        (error: any) => {
          console.log(error);
        }
      );
  }

  toggle(index: number) {
    this.withdrawals[index].toggle = !this.withdrawals[index].toggle;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.stateSubscription) this.stateSubscription.unsubscribe();
  }
}
